import { render, staticRenderFns } from "./OcSection.vue?vue&type=template&id=35d0ec2b&"
import script from "./OcSection.vue?vue&type=script&lang=js&"
export * from "./OcSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports